export function AnnotationIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_10918_6747)'>
        <circle cx='10.25' cy='1.75' r='1.25' stroke='currentColor' />
        <circle cx='10.25' cy='10.25' r='1.25' stroke='currentColor' />
        <circle cx='1.75' cy='10.25' r='1.25' stroke='currentColor' />
        <circle cx='1.75' cy='1.75' r='1.25' stroke='currentColor' />
        <path
          d='M3.68421 2H8.31579M3.68421 10H8.31579M2 8.31579V3.68421M10 8.31579V3.68421'
          stroke='currentColor'
          strokeLinecap='round'
          strokeDasharray='4 3'
        />
      </g>
      <defs>
        <clipPath id='clip0_10918_6747'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
